<div class="modalka-show-track-status" [class.track-status-modal-show]="isTrackStatusModalShow">
  <a class="close-modal" (click)="closeModal()"></a>
  <div *ngIf="trackStatusOrder && trackStatusOrder.status_id === 1" class="place-for-track-status-data">В процесі</div>
  <ng-container *ngIf="trackStatusOrderProductsWars">
    <div class="place-for-track-status">Переміщення</div>
    <div class="place-for-track-status" *ngFor="let op of trackStatusOrderProductsWars">
      З {{ op.to_w }} на {{ op.from_w }}
    </div>
    <ng-container *ngIf="trackStatusTransfer">
      <table class="track-status-table">
        <thead>
        <tr>
          <th>Дата прибуття</th>
          <th>Зі складу</th>
          <th>На склад</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let transfer of trackStatusTransfer">
          <td>{{ transfer.arrived_datetime | date: 'dd.MM.Y HH:mm:ss' }}</td>
          <td>{{ transfer.from_w }}</td>
          <td>{{ transfer.to_w }}</td>
          <td>{{ transfer.arrived ? 'Доставлено' : 'В дорозі' }}</td>
        </tr>
        </tbody>
      </table>
    </ng-container>
  </ng-container>
  <div class='track-status-center' *ngIf="trackStatusOrder && trackStatusOrder.trakstatus">
    {{ trackStatusOrder.trakstatus }}
  </div>
  <div class='track-status-center'
       *ngIf="trackStatusOrder && trackStatusOrder.datedelivery && trackStatusContactsDrivers">
    {{ trackStatusContactsDrivers.contacts }}
  </div>
</div>

<div class="dark-layer"
     [class.modals-show]="isDarkBackground"
     (click)="closeModal()">
</div>
